const isNullOrUndefined = <T>(
  obj: T | null | undefined,
): obj is null | undefined => typeof obj === 'undefined' || obj === null;

export default isNullOrUndefined;

export const notNull = <T>(obj: T | null): obj is T => {
  return obj !== null;
};
